import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  overlineText: {
    fontWeight: 500,
    fontSize: '0.75rem',
    color: 'rgba(0, 0, 0, 0.54)',
  },
  invitedGuardianItem: {
    border: '1px solid #E0E0E0',
    borderRadius: '0.25rem',
    padding: '1rem!important',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  center: {
    textAlign: 'center',
  },
  hideOnMobile: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  icon: {
    color: theme.palette.grey[600],
    fontSize: '1.25rem',
  },
  policiesSection: {
    boxSizing: 'border-box',
    padding: theme.spacing(0, 4.5, 4),
    maxWidth: '100%',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(0, 1, 4),
    },
  },
  invitedSection: {
    boxSizing: 'border-box',
    padding: theme.spacing(0, 4.5, 2),
    maxWidth: '100%',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(0, 1, 2),
    },
  },
  containerStyles: {
    boxSizing: 'border-box',
    padding: theme.spacing(3, 4.5, 2),
    maxWidth: '100%',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '60px',
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(3, 1, 2),
    },
  },
  tableShell: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
    backgroundColor: theme.palette.common.white,
    overflow: 'hidden',
  },
  filterButton: {
    height: 40,
    borderRadius: 8,
    fontWeight: 500,
    flexShrink: 0,
    borderColor: '#C4C7C9',
    color: '#172024',
    '& .MuiButton-endIcon': {
      color: '#6B7C87',
    },
  },
  filterButtonActive: {
    borderColor: theme.palette.primary.main,
    backgroundColor: '#E0EAFF',
    color: '#001C57',
    fontWeight: 600,
    '& .MuiButton-endIcon': {
      color: '#001C57',
    },
    '&:hover': {
      backgroundColor: '#D4E2FF',
      borderColor: theme.palette.primary.main,
    },
  },
  filterMenuPaper: {
    marginTop: theme.spacing(0.5),
    minWidth: 200,
  },
  filterMenuContent: {
    padding: theme.spacing(1.5, 2),
    boxSizing: 'border-box',
  },
  filterForm: {
    margin: 0,
    padding: 0,
    border: 0,
    minWidth: 0,
  },
  filterLegend: {
    display: 'block',
    fontSize: '0.6875rem',
    fontWeight: 600,
    lineHeight: 1.3,
    color: '#6B7C87',
    padding: 0,
    margin: 0,
    marginBottom: theme.spacing(1),
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
  },
  filterRadioGroup: {
    padding: 0,
    margin: 0,
  },
  filterRadioLabel: {
    margin: 0,
    width: '100%',
    minHeight: 40,
    marginLeft: 0,
    marginRight: 0,
    '& .MuiFormControlLabel-label': {
      fontSize: '0.875rem',
      lineHeight: '20px',
      color: '#172024',
    },
    '& .MuiRadio-root': {
      color: '#40484C',
      padding: theme.spacing(1),
    },
    '& .MuiRadio-colorPrimary.Mui-checked': {
      color: '#0053FF',
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    width: '100%',
    boxSizing: 'border-box',
    padding: theme.spacing(1.5, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
    },
  },
  searchGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    flex: '1 1 0',
    minWidth: 0,
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      width: '100%',
    },
  },
  searchField: {
    flex: '1 1 0',
    minWidth: 0,
    maxWidth: 360,
    width: '100%',
  },
  toolbarActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    flexShrink: 0,
    marginLeft: 'auto',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 'auto',
    },
  },
  tableContent: {
    padding: theme.spacing(0, 1, 1),
  },
  listEmptyStateContent: {
    padding: theme.spacing(4, 2),
  },
}))

export { useStyles }
